// TODO Log somewhere

export const logDebug = (message: string) => {
  console.debug(message)
}

export const logInfo = (message: string) => {
  console.info(message)
}

export const logWarning = (message: string) => {
  console.warn(message)
}

export const logError = (error: Error) => {
  console.error(error)
}
